import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { CreateQuickKeyRootParamList } from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { ColorPickerScreen } from "../ColorPickerScreen";
import { CreateCustomUrlQuickKeyScreen } from "../CreateCustomUrlQuickKeyScreen";
import { CreateFilterQuickKeyRootScreen } from "../CreateFilterQuickKeyRootScreen";
import { CreateProductQuickKeyRootScreen } from "../CreateProductQuickKeyRootScreen";
import { CreateQuickKeyTypeListScreen } from "../CreateQuickKeyTypeListScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";

export type CreateQuickKeyRootScreenProps = NativeStackScreenProps<
  CreateQuickKeyRootParamList,
  "CreateCustomUrlQuickKeyScreen"
>;

export const CreateQuickKeyRootScreen = ({
  navigation,
}: CreateQuickKeyRootScreenProps) => {
  const Stack = createStackHeaderNavigator<CreateQuickKeyRootParamList>();
  return (
    <Stack.Navigator
      screenOptions={{
        headerLeft: () => <ModalCloseButton />,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Screen
        name="CreateQuickKeyTypeListScreen"
        component={CreateQuickKeyTypeListScreen}
        options={{
          title: "",
        }}
      />

      <Stack.Group
        screenOptions={{
          animationEnabled: true,
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
        }}
      >
        <Stack.Screen
          name="CreateFilterQuickKeyRootScreen"
          component={CreateFilterQuickKeyRootScreen}
          options={{ title: "Create Filter Quick Key", headerShown: false }}
        />
        <Stack.Screen
          name="CreateCustomUrlQuickKeyScreen"
          component={CreateCustomUrlQuickKeyScreen}
          options={{ title: "Create Action Quick Key" }}
        />
        <Stack.Screen
          name="CreateProductQuickKeyRootScreen"
          component={CreateProductQuickKeyRootScreen}
          options={{
            title: "Create Product Quick Key",
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="ColorPickerScreen"
          component={ColorPickerScreen}
          options={{ title: "Select Color" }}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
